import React from 'react';
import InputFlexBox from 'components/container/InputFlexBox';
import InputWrappingBox from 'components/container/InputWrappingBox';
import styled from 'styled-components';
import EpsiodeContent from '../EpisodeContent';
import { IEpisodesDetail, ISupportLanguage } from 'utils/types/storyTypes';
import FormRightContent from './FormRightContent';
import { message } from 'antd';
import { handleMessage } from 'utils/helper/message';
import AddLanguageButton from 'components/AddLanguageButton';

interface IProps {
  supportLangList: ISupportLanguage[] | null;
  data: IEpisodesDetail | null;
  setData: React.Dispatch<React.SetStateAction<IEpisodesDetail | null>>;
}

const EpisodeWrapper: React.FC<IProps> = ({
  supportLangList,
  data,
  setData,
}) => {
  const handleAddLanguage = () => {
    if (data) {
      if (data.details.length > 6) {
        handleMessage(message, 'error', 'Episode only can have 7 languages');
      } else {
        const cloneArr = [...data.details];
        cloneArr.push({
          id: null,
          lang: 'KO',
          title: '',
          summary: '',
        });
        const cloneData = JSON.parse(JSON.stringify(data));
        cloneData['details'] = cloneArr;
        setData(cloneData);
      }
    }
  };
  return (
    <div>
      <InputFlexBox>
        {/* 다국어 */}
        <ListFormLeftWrapping>
          {data?.details?.map((el, i) => {
            return (
              <InputWrappingBox left key={i}>
                <EpsiodeContent
                  index={i}
                  langList={supportLangList}
                  detailData={el}
                  data={data}
                  setData={setData}
                />
              </InputWrappingBox>
            );
          })}
        </ListFormLeftWrapping>

        <ListFormRightWrapping>
          <FormRightContent data={data} setData={setData} />
        </ListFormRightWrapping>
      </InputFlexBox>
      <AddLanguageButton handleAddLanguage={handleAddLanguage} />
    </div>
  );
};

export default EpisodeWrapper;

const ListFormLeftWrapping = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  row-gap: 24px;
  margin-right: 1.5rem;
`;
const ListFormRightWrapping = styled.div`
  width: 100%;
`;
